// removed by extract-text-webpack-plugin
module.exports = {"Documents":"Documents__Documents___3TxUI","Title":"Documents__Title___2Jf5f","TitleClient":"Documents__TitleClient___gFXsQ","DocumentsList":"Documents__DocumentsList___18eRA","Document":"Documents__Document___8uVSD","DocumentIcon":"Documents__DocumentIcon___wVGIM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Building/Main/Documents/Documents.scss
// module id = 1350
// module chunks = 0